<template>
  <aside>
    <section class="hidden lg:block pb-12">
      <ProductActionPanel
        :blogContent="items"
        :thorneVerifiedData="thorneVerifiedData" 
        :product="product"
        :activeProductId="activeProductId"
        @bundle-select="onBundleSelect"
        add-to-cart-id="buybox"
      />
    </section>
    <hr class="border-t-top border-t-gray-300 absolute left-0 w-full md:w-[26.5vw]" />
    <section class="px-8 pr-0 lg:px-12 lg:pr-0 pb-12"
             aria-label="Thorne Verified"
             v-if="thorneVerifiedData && thorneVerifiedData?.length">
      <ThorneVerified :thorneVerifiedData="thorneVerifiedData" />
    </section>
    <section
      class="px-8 pr-0 lg:px-12 lg:pr-0"
      aria-label="Collection Methods and Biomarker Information"
    >
      <Collection :collectionMethods="product?.collectionMethods" v-if="product?.collectionMethods?.length" />
      <WeMeasure :biomarkerGroups="product?.biomarkerGroups" v-if="product?.biomarkerGroups?.length"/>
    </section>
    <HowToUse
      v-if="product?.suggestedUse"
      :suggestedUse="product?.suggestedUse"
    />
    <section class="px-6 py-5 lg:p-12 lg:pr-0" aria-label="Related Categories">
      <RelatedCategories :benefits="product?.benefits"
                         :healthConcerns="product?.healthConcerns"
                         :relatedProductBundles="product?.relatedProductBundles"
      />
    </section>
    <ArticlesSection :heading="heading" :items="items" />
  </aside>
</template>

<script setup lang="ts">
import ArticlesSection from '../../organism/product/sideBar/articlesSection.vue'
import HowToUse from '../../organism/product/sideBar/productUsage.vue'
import RelatedCategories from '../../organism/product/sideBar/relatedCategories.vue'
import ThorneVerified from '../../organism/product/sideBar/thorneVerified.vue'
import Collection from '../../organism/product/sideBar/collection.vue'
import WeMeasure from '../../organism/product/sideBar/weMeasure.vue'
import ProductActionPanel from '../../organism/product/productActionPanel.vue'
import type { Article } from '~~/shared/types/common'

const props = defineProps<{
  heading?: string
  items: Article[],
  product: Product | undefined
  thorneVerifiedData?: { label: string; link: string; icon: string }[]
  activeProductId: number
}>();

const product = computed(() => props.product)

const onBundleSelect = (variant: any) => {
  if (!variant?.productUrl) return
  navigateTo(`${variant.productUrl}`, { external: true })
}
</script>
